/* Grondyke · Page content
   Builds the sticky contents rail from the body's H2 headings. Below the minimum count
   (data-rail-min, default 3) the rail stays hidden and the body keeps its single column. */
(function () {
  function slug(text) {
    return (text || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
  }
  function init(root) {
    if (root.dataset.gkReady) return;
    root.dataset.gkReady = '1';
    var body = root.querySelector('[data-gk-body]');
    var rail = root.querySelector('[data-gk-rail]');
    var nav = root.querySelector('[data-gk-rail-nav]');
    if (!body || !rail || !nav) return;
    var min = parseInt(root.dataset.railMin, 10) || 3;
    var heads = body.querySelectorAll('h2');
    if (heads.length < min) return;
    var used = {};
    nav.innerHTML = '';
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      var id = h.id || slug(h.textContent);
      var base = id, n = 2;
      while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) { id = base + '-' + n++; }
      used[id] = true;
      h.id = id;
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      nav.appendChild(a);
    }
    rail.hidden = false;
    root.setAttribute('data-rail', 'on');
  }
  function boot() {
    var roots = document.querySelectorAll('[data-gk-content]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
